import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMapLevel } from "@evergis/react";
import { ActionsGroup, Dialog, DialogActions, FlatButton, RaisedButton } from "@evergis/ui";

import { Description, DialogContent, Slider, Title } from "./styled";
import { useLayerFromDialog } from "../../../hooks/layer/useLayerFromDialog";
import { useDialogInfo } from "../../../hooks/useDialogs";
import { useLayerMinMaxScale } from "./hooks/useLayerMinMaxScale";
import { useScaleRestrictionUpdate } from "./hooks/useScaleRestrictionUpdate";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";

export const ScaleRestriction: FC = () => {
  const { t } = useTranslation();
  const { closeDialog } = useDialogInfo(true);
  const mapLevel = useMapLevel();
  const { layer } = useLayerFromDialog();
  const { scale, setScale, resetScale } = useLayerMinMaxScale(layer);
  const updateLayer = useScaleRestrictionUpdate(layer, scale);
  const defaultScaleRange = useDefaultScaleRange();

  return (
    <Dialog isOpen onCloseRequest={closeDialog} modal maxWidth={"43.125rem"} minHeight={"16rem"}>
      <DialogContent>
        <Title>{t("scaleRestriction.dialogHeader", { ns: "dialogs" })}</Title>
        <Description>{layer ? layer.alias : t("layer", { ns: "common" })}</Description>
        <Slider
          value={scale}
          min={defaultScaleRange[0]}
          max={defaultScaleRange[1]}
          marks={defaultScaleRange.includes(mapLevel) ? defaultScaleRange : [mapLevel]}
          markLabels
          range
          primary
          onChange={setScale}
        />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={updateLayer}>
            {t("actions.apply", { ns: "common" })}
          </RaisedButton>
          <FlatButton onClick={closeDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
          <FlatButton onClick={resetScale}>{t("actions.reset", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
